module.exports = __webpack_public_path__ + "img/upload-image.484bd93c.svg";